/**
 * @generated SignedSource<<13fe102ac6dcdb43a885cd593cfb7927>>
 * @relayHash 82666ecfd74933314a41813fcc529a86
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 82666ecfd74933314a41813fcc529a86

import { ConcreteRequest } from 'relay-runtime';
export type DocumentType = "AUDIO" | "PDF" | "PHOTO" | "VIDEO";
export type FileUploadSource = "DOC2_U" | "PATIENT" | "SOFIA";
export type FileUploadStatus = "ERROR" | "HYPERLINK_PROCESSING_FAILED" | "JAVA_SCRIPT_PROCESSING_FAILED" | "MALICIOUS" | "NO_THREAT_FOUND" | "SCAN_TIMEOUT" | "UPLOADED";
export type UploadAppointmentFilesInput = {
  appointmentId: string;
  files: ReadonlyArray<any>;
};
export type useUploadMutation$variables = {
  input: UploadAppointmentFilesInput;
};
export type useUploadMutation$data = {
  readonly uploadAppointmentFiles: {
    readonly uploadAppointmentFilesOutput: {
      readonly attachments?: ReadonlyArray<{
        readonly attachmentType: DocumentType;
        readonly fileName: string;
        readonly id: string;
        readonly thumbnailUrl: string | null;
        readonly uploadDate: string;
        readonly uploadSource: FileUploadSource;
        readonly uploadStatus: FileUploadStatus | null;
        readonly url: string;
      }>;
      readonly error?: {
        readonly fileName: string | null;
        readonly message: string;
      };
      readonly isSuccess?: boolean;
    } | null;
  };
};
export type useUploadMutation = {
  response: useUploadMutation$data;
  variables: useUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSuccess",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AppointmentAttachment",
      "kind": "LinkedField",
      "name": "attachments",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbnailUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uploadDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "attachmentType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uploadStatus",
          "storageKey": null
        },
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uploadSource",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v3/*:: as any*/)
  ],
  "type": "SuccessUploadAppointmentFilesOutput",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UploadAppointmentFilesError",
      "kind": "LinkedField",
      "name": "error",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ErrorUploadAppointmentFilesOutput",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UploadAppointmentFilesPayload",
        "kind": "LinkedField",
        "name": "uploadAppointmentFiles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "uploadAppointmentFilesOutput",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UploadAppointmentFilesPayload",
        "kind": "LinkedField",
        "name": "uploadAppointmentFiles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "uploadAppointmentFilesOutput",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "82666ecfd74933314a41813fcc529a86",
    "metadata": {},
    "name": "useUploadMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ace57d8b45e572c34a73ab1e4a8d8f61";

export default node;
